import useTracking from './useTracking';
import { useEffect } from 'react';
import { useRouter } from 'next/router';

export default function useViewEvent(eventName, eventProperties = {}) {
  const tracking = useTracking();
  const { query = undefined, pathname = undefined } = useRouter() || {};
  useEffect(() => {
    tracking.logEvent(eventName, {
      pathname: pathname,
      query: query,
      ...eventProperties
    });
  }, []);
}
